import { render, staticRenderFns } from "./Retirement.vue?vue&type=template&id=673b07ff&"
import script from "./Retirement.vue?vue&type=script&lang=js&"
export * from "./Retirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports